// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"j5-z"};